import { render, staticRenderFns } from "./MallMainPageNeimeng.vue?vue&type=template&id=28fbac64&scoped=true"
import script from "./MallMainPageNeimeng.vue?vue&type=script&lang=js"
export * from "./MallMainPageNeimeng.vue?vue&type=script&lang=js"
import style0 from "./MallMainPageNeimeng.vue?vue&type=style&index=0&id=28fbac64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fbac64",
  null
  
)

export default component.exports